import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dbdc351")

_pushScopeId("data-v-7dbdc351")
const _hoisted_1 = { class: "bg-white flex flex-col overflow-hidden h-screen relative font-montserrat" }
const _hoisted_2 = { class: "px-6 py-3 border-b border-gray-lp-1400" }
const _hoisted_3 = { class: "font-semibold text-20px text-black-lp-300 capitalize" }
const _hoisted_4 = { class: "flex-1 min-h-0 bg-gray-lp-1000 p-3" }
const _hoisted_5 = { class: "bg-white rounded-xl h-full p-3 flex flex-col overflow-hidden" }
const _hoisted_6 = {
  class: "flex flex-row flex-wrap items-center gap-2 pb-4",
  "data-testid": "duty-tax-configuration-toolbar"
}
const _hoisted_7 = {
  class: "w-60",
  "data-testid": "duty-tax-configuration-filter-country"
}
const _hoisted_8 = {
  class: "duty-tax-table flex-1 min-h-0 w-full overflow-hidden",
  "data-testid": "duty-tax-configuration-table"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("main", _hoisted_4, [
      _createVNode("section", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearchInput,
            onClear: _ctx.onClearSearch,
            value: _ctx.searchValue,
            minChar: 0,
            timeout: 0,
            isIconLeft: true,
            customMargin: "",
            class: "w-300px",
            placeholder: "Cari kode/nama negara",
            onEnter: _ctx.onSearchTriggered
          }, null, 8, ["onInput", "onClear", "value", "onEnter"]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_SelectSearch, {
              options: _ctx.countryOptions,
              modelValue: _ctx.draftCountry,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.draftCountry = $event)),
              keyName: "name",
              keyValue: "value",
              isLoading: _ctx.isLoadingCountry,
              placeholder: "Semua negara tujuan",
              onFilter: _ctx.fetchCountryOptions
            }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
          ]),
          _createVNode(_component_Select, {
            dataSelect: _ctx.statusOptions,
            onOpenSelect: _ctx.onOpenStatus,
            onCloseSelect: _ctx.onCloseStatus,
            onChooseSelect: _ctx.onSelectStatus,
            value: _ctx.statusTitle,
            isOpenMenu: _ctx.isStatusOpen,
            isDefaultBlack: false,
            class: "w-40"
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"]),
          _createVNode("button", {
            type: "button",
            class: "text-14px text-white bg-red-lp-2400 hover:bg-red-lp-100 px-5 py-2.5 rounded-md font-semibold",
            "data-testid": "duty-tax-configuration-filter-apply",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onApplyFilter && _ctx.onApplyFilter(...args)))
          }, " Terapkan ")
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_TableV2, {
            borderTop: false,
            borderBottom: false,
            borderRowColor: "border-gray-lp-1400",
            bgHeader: "bg-white",
            headerTextColor: "text-black-lp-100",
            isBorderOnHeadBgWhite: true,
            isSpaceTop: false,
            isNoPaddingBottom: true,
            isEmpty: _ctx.isEmpty,
            columns: _ctx.columns,
            data: _ctx.listData.data,
            loading: _ctx.isLoading,
            errorCause: _ctx.errorCause,
            emptyHeaderMessage: "",
            emptyMessage: "Belum ada konfigurasi duty tax",
            pagination: _ctx.listData.pagination,
            "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listData.pagination = $event)),
            sortBy: _ctx.sortBy,
            sortDirection: _ctx.sortDirectionUi,
            onRequest: _ctx.fetchList,
            onSort: _ctx.onSort,
            onTryAgain: _ctx.fetchList,
            paginationStyle: "v3",
            paginationV3PaddingVertical: "px-4 py-4",
            customClassPagination: "border-t border-gray-lp-1400",
            pinnedSubstractHeight: "320px",
            isLeftFreeze: "",
            totalColumnFreeze: 2,
            isPinnedScrollBottom: ""
          }, null, 8, ["isEmpty", "columns", "data", "loading", "errorCause", "pagination", "sortBy", "sortDirection", "onRequest", "onSort", "onTryAgain"])
        ])
      ])
    ])
  ]))
})